import React, { Suspense, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import { ParentThemeLayout } from "./Layout";
import { Provider } from "react-redux";
import { store } from "./_store";

const resolveTitleFromHostname = (hostname) => {
  const host = (hostname || "").toLowerCase();

  const isStaging =
    host === "sostaging.uk";

  return isStaging ? "So Stanging" : "Sumo Ordering";
};

const TitleSetter = () => {
  const location = useLocation();

  useEffect(() => {
    document.title = resolveTitleFromHostname(window.location.hostname);
  }, [location.pathname]);

  return null;
};


const ChildTheme = (props) => {
  const createRoutes = () => {
    return <Route path="/*" element={<ParentThemeLayout />} />;
  };

  return (
    <Provider store={store}>
      <TitleSetter />
      <Routes>{createRoutes()}</Routes>
    </Provider>
  );
};

export default ChildTheme;
